import { TextField, Box } from '@mui/material';
import React from 'react';
import { DateRangePickerProps } from './interface';
import moment from 'moment';

const DateRangePicker = (props: DateRangePickerProps) => {
  const { endText, startText, onChange, value } = props;

  const handleStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = event.target.value;
    if (dateValue) {
      onChange([moment(dateValue), value[1]]);
    } else {
      onChange([null, value[1]]);
    }
  };

  const handleEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = event.target.value;
    if (dateValue) {
      onChange([value[0], moment(dateValue)]);
    } else {
      onChange([value[0], null]);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        label={startText}
        type="date"
        value={value[0] ? moment(value[0]).format('YYYY-MM-DD') : ''}
        onChange={handleStartDateChange}
        InputLabelProps={{ shrink: true }}
        autoComplete="off"
      />
      <Box sx={{ display: 'flex', alignItems: 'center', height: '40px' }}>-</Box>
      <TextField
        label={endText}
        type="date"
        value={value[1] ? moment(value[1]).format('YYYY-MM-DD') : ''}
        onChange={handleEndDateChange}
        InputLabelProps={{ shrink: true }}
        autoComplete="off"
      />
    </Box>
  );
};

export default DateRangePicker;
